(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-slideshow"] && !Shopify.designMode) return;
  try {
    
  class SplitSlideshow extends HTMLElement {
    constructor() {
      super();
      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onResize = this._debounce(this._onResize.bind(this), 150);
      this._onVisibilityChange = this._onVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this._originalSlides = Array.from(this.track.children);
      this._totalSlides = this._originalSlides.length;
      if (this._totalSlides < 2) return;

      this._interval = (parseFloat(this.dataset.interval) || 5) * 1000;
      this._autoplayEnabled = this.dataset.autoplay !== 'false';

      this._currentIndex = 0;
      this._isDragging = false;
      this._dragStartX = 0;
      this._dragDelta = 0;
      this._dragBaseX = 0;
      this._didDrag = false;
      this._transitionMs = 600;
      this._easing = 'cubic-bezier(0.65, 0, 0.35, 1)';

      this._build();
      this._bindEvents();

      if (this._autoplayEnabled && !this._reducedMotion()) {
        this._startAutoplay();
      }

      // Theme editor support
      document.addEventListener('shopify:section:load', this._onSectionLoad?.bind(this));
    }

    disconnectedCallback() {
      this._stopAutoplay();
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
      if (this._resizeObserver) this._resizeObserver.disconnect();
      if (this._intersectionObserver) this._intersectionObserver.disconnect();
    }

    _reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _getSlidesPerView() {
      return window.matchMedia('(min-width: 750px)').matches ? 2 : 1;
    }

    _build() {
      this._slidesPerView = this._getSlidesPerView();

      // Reset track to original slides
      while (this.track.firstChild) this.track.removeChild(this.track.firstChild);
      this._originalSlides.forEach((slide) => {
        slide.removeAttribute('aria-hidden');
        delete slide.dataset.clone;
        slide.querySelectorAll('a, button').forEach((el) => el.removeAttribute('tabindex'));
        this.track.appendChild(slide);
      });

      // Prepend clones of last N slides for backward looping
      for (let i = 0; i < this._slidesPerView; i++) {
        const idx = this._totalSlides - this._slidesPerView + i;
        const clone = this._originalSlides[idx].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'start';
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.insertBefore(clone, this.track.firstChild);
      }

      // Append clones of first N slides for forward looping
      for (let i = 0; i < this._slidesPerView; i++) {
        const clone = this._originalSlides[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'end';
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      }

      this._startOffset = this._slidesPerView;
      this._measure();
      this._setPosition(this._currentIndex, false);
    }

    _measure() {
      this._slideWidth = this.offsetWidth / this._slidesPerView;
    }

    _setPosition(logicalIndex, animate) {
      this._currentIndex = logicalIndex;
      const trackIndex = logicalIndex + this._startOffset;
      const offset = -trackIndex * this._slideWidth;

      this.track.style.transition =
        animate && !this._reducedMotion()
          ? 'transform ' + this._transitionMs + 'ms ' + this._easing
          : 'none';
      this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

      if (animate) this._scheduleLoopReset();
    }

    _scheduleLoopReset() {
      if (this._loopHandler) {
        this.track.removeEventListener('transitionend', this._loopHandler);
      }
      this._loopHandler = (e) => {
        if (e.propertyName !== 'transform') return;
        this.track.removeEventListener('transitionend', this._loopHandler);
        this._loopHandler = null;

        if (this._currentIndex >= this._totalSlides) {
          this._setPosition(this._currentIndex - this._totalSlides, false);
        } else if (this._currentIndex < 0) {
          this._setPosition(this._currentIndex + this._totalSlides, false);
        }
      };
      this.track.addEventListener('transitionend', this._loopHandler);
    }

    next() {
      this._setPosition(this._currentIndex + 1, true);
    }

    prev() {
      this._setPosition(this._currentIndex - 1, true);
    }

    _startAutoplay() {
      this._stopAutoplay();
      if (!this._autoplayEnabled) return;
      this._autoplayTimer = setInterval(() => {
        if (!this._isDragging && document.visibilityState === 'visible' && this._inView !== false) {
          this.next();
        }
      }, this._interval);
    }

    _stopAutoplay() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    _bindEvents() {
      this.addEventListener('pointerdown', this._onPointerDown);
      this.addEventListener('pointermove', this._onPointerMove);
      this.addEventListener('pointerup', this._onPointerUp);
      this.addEventListener('pointercancel', this._onPointerUp);

      this.addEventListener('mouseenter', () => this._stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this._autoplayEnabled && !this._reducedMotion()) this._startAutoplay();
      });

      this.addEventListener('focusin', () => this._stopAutoplay());
      this.addEventListener('focusout', () => {
        if (this._autoplayEnabled && !this._reducedMotion()) this._startAutoplay();
      });

      // Native browser drag (e.g. on images) interferes with pointer drag
      this.addEventListener('dragstart', (e) => e.preventDefault());

      // Suppress click on links if a drag occurred
      this.addEventListener(
        'click',
        (e) => {
          if (this._didDrag) {
            e.preventDefault();
            e.stopPropagation();
            this._didDrag = false;
          }
        },
        true
      );

      window.addEventListener('resize', this._onResize);
      document.addEventListener('visibilitychange', this._onVisibilityChange);

      if ('IntersectionObserver' in window) {
        this._intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this._inView = entry.isIntersecting;
              if (entry.isIntersecting && this._autoplayEnabled && !this._reducedMotion()) {
                this._startAutoplay();
              } else {
                this._stopAutoplay();
              }
            });
          },
          { threshold: 0.1 }
        );
        this._intersectionObserver.observe(this);
      }
    }

    _onPointerDown(e) {
      // Only primary mouse button; touch and pen are also fine
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      this._stopAutoplay();

      // Read current visual transform so dragging mid-transition feels seamless
      let currentX = 0;
      const computed = window.getComputedStyle(this.track).transform;
      if (computed && computed !== 'none' && 'DOMMatrixReadOnly' in window) {
        try {
          currentX = new DOMMatrixReadOnly(computed).m41;
        } catch (_) {}
      }

      // Cancel any pending loop reset
      if (this._loopHandler) {
        this.track.removeEventListener('transitionend', this._loopHandler);
        this._loopHandler = null;
      }

      // Pin track to its current visual position
      this.track.style.transition = 'none';
      this.track.style.transform = 'translate3d(' + currentX + 'px, 0, 0)';

      // Sync logical index to whichever slide we're closest to visually
      const visualTrackIndex = Math.round(-currentX / this._slideWidth);
      this._currentIndex = visualTrackIndex - this._startOffset;

      this._isDragging = true;
      this._dragStartX = e.clientX;
      this._dragDelta = 0;
      this._didDrag = false;
      this._dragBaseX = currentX;
      this.dataset.isDragging = 'true';

      try {
        this.setPointerCapture(e.pointerId);
      } catch (_) {}
    }

    _onPointerMove(e) {
      if (!this._isDragging) return;
      this._dragDelta = e.clientX - this._dragStartX;
      if (Math.abs(this._dragDelta) > 5) this._didDrag = true;

      const offset = this._dragBaseX + this._dragDelta;
      this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    _onPointerUp() {
      if (!this._isDragging) return;
      this._isDragging = false;
      delete this.dataset.isDragging;

      const threshold = this._slideWidth * 0.2;
      if (this._dragDelta < -threshold) {
        this.next();
      } else if (this._dragDelta > threshold) {
        this.prev();
      } else {
        this._setPosition(this._currentIndex, true);
      }

      this._dragDelta = 0;

      if (this._autoplayEnabled && !this._reducedMotion()) {
        this._startAutoplay();
      }
    }

    _onResize() {
      const newSlidesPerView = this._getSlidesPerView();
      if (newSlidesPerView !== this._slidesPerView) {
        this._build();
      } else {
        this._measure();
        this._setPosition(this._currentIndex, false);
      }
    }

    _onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        if (this._autoplayEnabled && !this._reducedMotion()) this._startAutoplay();
      } else {
        this._stopAutoplay();
      }
    }

    _debounce(fn, wait) {
      let t;
      return function () {
        const args = arguments;
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('split-slideshow')) {
    customElements.define('split-slideshow', SplitSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
